// A long date ('28 July 2027') in the learner's interface language.
// Browsers without the locale's date data (Chromium builds, Android Chrome
// for Welsh and Irish) silently answer in American English, which put
// 'Am ddim tan July 28, 2027' on the Welsh picker. Welsh and Irish carry
// their own month names here; any other unsupported tag falls back to
// British English rather than American.
const MONTHS: Record<string, string[]> = {
  cy: ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr'],
  ga: ['Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Meitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deireadh Fómhair', 'Samhain', 'Nollaig'],
}
const LONG: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
const formatters = new Map<string, Intl.DateTimeFormat>()

function formatDate(when: Date, tag: string): string {
  // Date#toLocaleDateString accepts invalid dates; Intl#format throws for them.
  if (Number.isNaN(when.getTime())) return when.toLocaleDateString(tag, LONG)
  let formatter = formatters.get(tag)
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(tag, LONG)
    formatters.set(tag, formatter)
  }
  return formatter.format(when)
}

// Picker renders usually share one interface language. Keep just the latest
// support result so repeated dates avoid locale negotiation without growing a cache.
let localeSupport: { tag: string | undefined; supported: boolean } | undefined

function supportsDateLocale(tag: string | undefined): boolean {
  if (localeSupport && localeSupport.tag === tag) return localeSupport.supported
  let supported = false
  try { supported = !!tag && Intl.DateTimeFormat.supportedLocalesOf([tag]).length > 0 } catch { supported = false }
  localeSupport = { tag, supported }
  return supported
}

export function formatLongDate(when: Date, tag: string | undefined): string {
  const base = (tag || '').split('-')[0].toLowerCase()
  const supported = supportsDateLocale(tag)
  if (!Number.isNaN(when.getTime()) && !supported && Object.prototype.hasOwnProperty.call(MONTHS, base)) {
    return `${when.getDate()} ${MONTHS[base][when.getMonth()]} ${when.getFullYear()}`
  }
  try {
    return formatDate(when, supported ? tag! : 'en-GB')
  } catch {
    return formatDate(when, 'en-GB')
  }
}
